/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
import { apiClient, handleResponse } from './axios';

async function getAll(companyId) {
  try {
    const response = await apiClient
      .get(`/group/company/${companyId}`);
    const groups = await handleResponse(response);
    return groups;
  } catch (err) {
    return console.error(err);
  }
}

async function deleteExam(elearningOptionsId) {
  try {
    const response = await apiClient
      .put(`/exam/delete/${elearningOptionsId}`);
    const elearning = await handleResponse(response);
    return elearning;
  } catch (err) {
    return console.error(err);
  }
}
async function getGroupByCompanyList(companyId) {
  try {
    const groups = await apiClient
      .get(`/group/company/${companyId}`);
    return groups;
  } catch (err) {
    return console.error(err);
  }
}

async function getGroupsDataByCompagny(companyId) {
  try {
    const res = await apiClient
      .get(`/group/company/${companyId}`);
    const groups = res;
    return groups;
  } catch (err) {
    return console.error(err);
  }
}

async function updateGroup(groupId, body) {
  try {
    const response = await apiClient
      .put(`/group/${groupId}`, body);
    const groups = await handleResponse(response);
    return groups;
  } catch (err) {
    return console.error(err);
  }
}

async function getGroupsByCompany(companyId) {
  try {
    const response = await apiClient
      .get(`/groups/${companyId}`);
    const groups = await handleResponse(response);
    return groups;
  } catch (err) {
    return console.error(err);
  }
}

async function getGroupWithTestResults(groupId) {
  try {
    const response = await apiClient
      .get(`/group/tests/${groupId}`);
    const group = await handleResponse(response);
    return group;
  } catch (err) {
    return console.error(err);
  }
}

async function addUserToGroup(groupId, body) {
  try {
    const response = await apiClient
      .put(`/group/user/${groupId}`, body);
    const groups = await handleResponse(response);
    return groups;
  } catch (err) {
    return console.error(err);
  }
}

async function deleteUserGroup(groupId, userId) {
  try {
    const response = await apiClient
      .delete(`/group/${groupId}/${userId}`);
    const data = await handleResponse(response);
    return data;
  } catch (err) {
    return console.error(err);
  }
}

async function getGroupByUser(userId) {
  try {
    const response = await apiClient
      .get(`/group/user/${userId}`);
    const groups = await handleResponse(response);
    return groups;
  } catch (err) {
    return console.error(err);
  }
}

async function getCoursePlan(groupId) {
  try {
    const response = await apiClient
      .get(`/export/pdf/group/${groupId}`);
    const groups = await handleResponse(response);
    return groups;
  } catch (err) {
    return console.error(err);
  }
}

async function getGroupsByTeacher(teacherId) {
  try {
    const response = await apiClient
      .get(`/group/byteacher/${teacherId}`);
    const groups = await handleResponse(response);
    return groups;
  } catch (err) {
    return console.error(err);
  }
}

async function getGroupsByTeacherWithReports(teacherId) {
  try {
    const response = await apiClient
      .get(`/group/byteacher/reports/${teacherId}`);
    const groups = await handleResponse(response);
    return groups;
  } catch (err) {
    return console.error(err);
  }
}

const formatTeacher = (teachers) => {
  try {
    const formatedTeachers = [];
    for (let i = 0; i < teachers.length; i++) {
      formatedTeachers.push({
        label: `${teachers[i].name} ${teachers[i].firstname}`,
        value: teachers[i].name,
        id: teachers[i]._id,
      });
    }
    return formatedTeachers;
  } catch (err) {
    return console.error(err);
  }
};

const formatCourses = (courses) => {
  try {
    const formatedCourses = [];
    for (let i = 0; i < courses.length; i++) {
      formatedCourses.push({
        label: courses[i].name,
        value: courses[i].name,
        id: courses[i]._id,
      });
    }
    return formatedCourses;
  } catch (err) {
    return console.error(err);
  }
};

async function getGroupById(groupId) {
  try {
    const reponse = await apiClient
      .get(`/group/${groupId}`);
    reponse.data.idTeachers = formatTeacher(reponse.data.idTeachers);
    reponse.data.courses = formatCourses(reponse.data.courses);
    return reponse.data;
  } catch (error) {
    return error;
  }
}

async function getGroupWithStudents(groupId) {
  try {
    const response = await apiClient
      .get(`/group/${groupId}`);
    const group = await handleResponse(response);
    return group;
  } catch (err) {
    return console.error(err);
  }
}

async function getGroupWithExamResults(groupId, body) {
  try {
    const response = await apiClient
      .post(`/group/exam/result/${groupId}`, body);
    const group = await handleResponse(response);
    return group;
  } catch (err) {
    return console.error(err);
  }
}

async function getGroupsWithExam() {
  try {
    const reponse = await apiClient
      .get('/group/exam');
    return reponse.data;
  } catch (error) {
    return error;
  }
}

async function getGroupsWithExamAndTeacherId(teacherId) {
  try {
    const reponse = await apiClient
      .get(`/group/teacher/exam/${teacherId}`);
    return reponse;
  } catch (error) {
    return error;
  }
}

async function getGroupWithExam(groupId) {
  try {
    const reponse = await apiClient
      .get(`/group/exam/${groupId}`);
    reponse.data.idTeachers = formatTeacher(reponse.data.idTeachers);
    reponse.data.courses = formatCourses(reponse.data.courses);
    return reponse.data;
  } catch (err) {
    return console.error(err);
  }
}

async function getGroupByCoursePlan(courseplanId) {
  try {
    const response = await apiClient
      .get(`/group/courseplan/${courseplanId}`);
    const group = await handleResponse(response);
    return group;
  } catch (err) {
    return console.error(err);
  }
}

export const groupServices = {
  getAll,
  getGroupByCompanyList,
  deleteUserGroup,
  addUserToGroup,
  getGroupById,
  deleteExam,
  getGroupByUser,
  getGroupsDataByCompagny,
  getGroupsByCompany,
  getGroupsByTeacher,
  getGroupsByTeacherWithReports,
  updateGroup,
  getCoursePlan,
  getGroupsWithExam,
  getGroupWithExam,
  getGroupWithStudents,
  getGroupWithExamResults,
  getGroupByCoursePlan,
  getGroupWithTestResults,
  getGroupsWithExamAndTeacherId,
};
